export interface SessionScore {
	team0: number;
	team1: number;
}

interface ResultDetail {
	field_goal_result?: string;
	field_goal_position?: string;
	team_id?: number;
}

export const calculateSessionScores = (
	resultDetails: unknown[] | null | undefined,
): SessionScore => {
	if (!resultDetails || !Array.isArray(resultDetails)) {
		return { team0: 0, team1: 0 };
	}

	let team0 = 0;
	let team1 = 0;

	for (const result of resultDetails as ResultDetail[]) {
		if (result.field_goal_result === "score" && result.team_id != null) {
			const points = result.field_goal_position === "3PFG" ? 3 : 2;
			if (result.team_id === 0) {
				team0 += points;
			} else if (result.team_id === 1) {
				team1 += points;
			}
		}
	}

	return { team0, team1 };
};
